export const cilSignalCellular4 = ["24 24","<path d='M18.037 4.125h-0.005v0.005l-17.282 17.282v1.838h22.5v-22.5h-1.838zM15.407 8.876l2.625-2.625v15.499h-2.625zM13.907 21.75h-2.625v-8.749l2.625-2.625zM9.782 21.75h-2.625v-4.624l2.625-2.625zM5.657 18.626v3.124h-3.124zM21.75 21.75h-2.218v-16.999l2.218-2.218z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-signal-cellular-4.js
// module id = null
// module chunks = 